<template>
  <BackgroundImageComponent></BackgroundImageComponent>
  <div class="container mt-4 position-relative">
    <div class="row mb-4">
      <div class="col-12 text-center text-lg-start">
        <div class="card mb-4 mb-md-0">
          <div class="card-body">
            <div class="d-flex text-ruderclub-orange">
              <h1>Trainingsauswahl</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-4 col-md-6 mb-md-0">
        <div class="card auswahl-card-link">
          <div
            class="card-img-top d-flex justify-content-center align-items-center"
            style="height: 150px; background-color: var(--ruderclub-dark-green)"
          >
            <span
              class="material-symbols-outlined"
              style="font-size: 80px; color: var(--ruderclub-orange)"
            >
              movie
            </span>
          </div>
          <div class="card-body">
            <h5 class="card-title">Video</h5>
            <p class="card-text" style="height: auto; min-height: 72px">
              Trainiere mithilfe von Landschafts- oder Trainingsvideos, um eine
              immersivere Trainingserfahrung zu genießen.
            </p>
            <router-link
              to="/training/video/dashboard"
              class="btn btn-outline-ruderclub-orange w-100"
              >Starten</router-link
            >
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="card auswahl-card-link">
          <div
            class="card-img-top d-flex justify-content-center align-items-center"
            style="height: 150px; background-color: var(--ruderclub-dark-green)"
          >
            <span
              class="material-symbols-outlined"
              style="font-size: 80px; color: var(--ruderclub-orange)"
            >
              map
            </span>
          </div>
          <div class="card-body">
            <h5 class="card-title">Karte</h5>
            <p class="card-text" style="height: auto">
              Du wirst auf vorgefertigen Strecken auf einer Kartenansicht
              trainieren. Verbessere Deine Zeit oder schalte einfach bei einem
              Podcast ab und lerne die Umgebung der Strecke kennen.
            </p>
            <router-link
              to="/training/map"
              class="btn btn-outline-ruderclub-orange w-100"
              >Starten</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundImageComponent from "@/components/Shared/BackgroundImageComponent.vue";

export default {
  components: { BackgroundImageComponent },
};
</script>

<style scoped>
.card-text {
  height: 75px;
}

.auswahl-card-link {
  border-color: var(--ruderclub-dark-green);
}
.auswahl-card-link:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border-color: var(--ruderclub-orange);
}
</style>
